const prettyDateTime = (dateTime) => {
    const actualDate = new Date();
    const actualDay = String(actualDate.getDate()).padStart(2, '0')
    const dateTimeString = dateTime;
    const dateTimeAfter = new Date(dateTimeString);

    const hours = dateTimeAfter.getHours();
    const minutes = dateTimeAfter.getMinutes().toString().padStart(2, '0'); // Přidáme padStart pro formát minut

    const day = String(dateTimeAfter.getDate()).padStart(2, '0');
    if(actualDay === day){
        return `${hours}:${minutes}  dnes`;
    } else {
        return `${hours}:${minutes}  zítra`;
    }  
   
}

export default prettyDateTime;
